<template>
    <div class="block lg:hidden footer-menu-dummy"></div>
    <div class="block lg:hidden fixed bottom-0 left-0 w-screen bg-a-egg-f5ebdc z-index-fixed">
        <div class="bg-a-brown-502314 relative" v-if="isShowDownload">
            <div class="px-4 py-1.5 flex items-center">
                <div><img class="h-9 w-9" src="../../../../assets/logo/Logo-brown.png" /></div>
                <div class="pl-5 text-white text-12">
                    <div>{{lbl.main.menubar.bk_app}}</div>
                    <div>{{lbl.main.menubar.download}}</div>
                </div>
                <div class="ml-auto mr-9 flex" @click="clickDownload()">
                    <div class="text-12 text-a-brown-502314 bg-a-egg-f5ebdc rounded px-1.5">{{lbl.main.menubar.download2}}</div>
                </div>
                <div class="absolute right-1 top-1" @click="clickCloseDownload()">
                    <img class="h-3.5" src="../../../../assets/icon/ic-close-white.png" />
                </div>
            </div>
        </div>
        <div class="grid grid-cols-5 text-a-brown-502314 pb-1 pt-2">
            <router-link to="/home" class="flex flex-col items-center">
                <img v-if="isActiveMenu('home')" class="h-6" src="../../../../assets/menu_icon/ic-Home.svg">
                <img v-else class="h-6" src="../../../../assets/menu_icon/ic-Home-inactive.svg">
                <div class="text-12 text-center ellipsis" :class="[getClassTextActive('home')]">{{lbl.main.menubar.home}}</div>
            </router-link>
            <router-link to="/reward" class="flex flex-col items-center">
                <img v-if="isActiveMenu('reward')" class="h-6" src="../../../../assets/menu_icon/ic-Rewards-active.svg">
                <img v-else class="h-6" src="../../../../assets/menu_icon/ic-Rewards.svg">
                <div class="text-12 text-center ellipsis" :class="[getClassTextActive('reward')]">{{lbl.main.menubar.reward}}</div>
            </router-link>
            <router-link :to="earnUrl" class="flex flex-col items-center">
                <img v-if="isActiveMenu('EarnPoint')" class="h-6" src="../../../../assets/menu_icon/ic-earn-active.svg">
                <img v-else class="h-6" src="../../../../assets/menu_icon/ic-earn.svg">
                <div class="text-12 text-center ellipsis" :class="[getClassTextActive('EarnPoint')]">{{lbl.main.menubar.earn_point}}</div>
            </router-link>
            <router-link to="/myorder" class="flex flex-col items-center">
                <img v-if="isActiveMenu('MyOrder')" class="h-6" src="../../../../assets/menu_icon/ic-order-active.svg">
                <img v-else class="h-6" src="../../../../assets/menu_icon/ic-Tracking.svg">
                <div class="text-12 text-center ellipsis" :class="[getClassTextActive('MyOrder')]">{{lbl.main.menubar.my_order}}</div>
            </router-link>
            <router-link  to="/profile" class="flex flex-col items-center">
                <img v-if="isActiveMenu('profile')" class="h-6" src="../../../../assets/menu_icon/ic-More-active.svg">
                <img v-else class="h-6" src="../../../../assets/menu_icon/ic-More.svg">
                <div class="text-12 text-center ellipsis" :class="[getClassTextActive('profile')]">{{lbl.main.menubar.more}}</div>
            </router-link>
        </div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import Utility from '../../../../helper/Utility.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
export default {
    mixins: [LocaleMixin,AuthStatusMixin],
    data: function () {
        return {
            isShowDownload: true,
            earnUrl: '/earnpoint',
        }
    },
    methods: {
        onAccountInit: function () {
            if (this.isLoginGuest) {
                let path = this.$route.path;
                console.log(path)
                this.earnUrl = '/login?afterLogin=' + path;
            }
        },
        getClassTextActive: function (page) {
            let currentPage = this.$route.name;
            if (page == currentPage) {
                return 'text-a-red-d62300';
            }
            return '';
        },
        isActiveMenu: function (menu) {
            let currentPage = this.$route.name;
            return currentPage == menu;
        },
        clickCloseDownload: function () {
            this.isShowDownload = false;
        },
        clickDownload: function () {
            var appStoreUrl = 'https://apps.apple.com/th/app/burger-king-thailand/id1440299482?l=th';
            var playStoreUrl = 'https://play.google.com/store/apps/details?id=com.bzbs.burgerking';
            var url = "";
            if (Utility.checkSafari()){
                url = appStoreUrl;
            }
            else{
                url = playStoreUrl;
            }
            window.location.replace(url);
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/text.scss";
@import "@/style/base/base.scss";
    .footer-menu-dummy {
        height: $footer-menu-height;
    }
    .ellipsis {
        height: 18px;
        @extend %ellipsis-1;
    }
</style>
